module.exports = __webpack_public_path__ + "static/media/about-two.d8ff1479.png";